
import QRCodeGenerator from "../qrcode/QRCodeGenerator";
import { Box, Button, Divider,  Card, Typography, Grid } from "@mui/material";
import qrcode from 'qrcode';
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import useUserPermissions from "../../../components/user-permission/UserPermission";

const LabelPalletDetails = ({ qrCodeValue, ProductDetail }) => {
    // call print QR Code
    const userPermissions = useUserPermissions();
    
    const handleButtonClick = async (pallet_code) => {

        let isvalid = true;

        const palletdet = ProductDetail.find(
            (detail) => detail.pallet_code === pallet_code
        );

        if (palletdet.pallet_code === '') {
            isvalid = false;
        }


        if (isvalid == true) {


            const printWindow = window.open('', '_blank');
            try {
                // for (const qrCodeValue of palletdet) {
                // Generate HTML content for each QR code parentRollNumber
                // Generate QR code data URL
                const qrDataUrl = await generateQRCode(palletdet.pallet_code);
                // Check if QR code generation was successful
                if (!qrDataUrl) {
                    console.error('Error generating QR code for value:', palletdet.pallet_code);
                }
                // Write HTML content for the QR code to the print window
                printWindow.document.write(`

                <html>
                    <head>
                        <title>Printed Report</title>
                        <style>
                        body {
                            margin: 0;
                            padding: 0;
                            font-family: Arial, sans-serif;
                        }
                        .container {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 10px;
                            border: 1px solid #ccc;
                            box-sizing: border-box;
                        }
                        .qr-code {
                            width: 150px; /* Adjust as needed */
                        }
                        .bundle-details {
                            flex: 1;
                            margin-left: 20px; /* Adjust spacing between QR code and bundle details */
                        }
                        .bundle-details h5 {
                            margin: 0;
                            font-size: 18px;
                        }
                        .bundle-details h6 {
                            margin: 5px 0;
                            font-size: 16px;
                        }
                            .details-table {
                                    display: grid;
                                    grid-template-columns: 150px auto;
                                    gap: 10px 20px;
                                    margin-top: 10px;
                                }
                                .details-table div {
                                    font-size: 16px;
                                }
                                .details-table .label {
                                    font-weight: bold;
                                }
                                .bundle-details hr {
                                    margin: 10px 0;
                                    border: 1px solid #ccc;
                                }
                    </style>
                    </head>
                    <body>
                    <div class="container">
                    <div>
                        <img class="qr-code" src="${qrDataUrl}" alt="QR Code" />
                        <h3>${palletdet.pallet_code || 'XXXXXX0123'}</h3>
                    </div>
                    <div class="bundle-details">
                        <h5>PALLET DETAILS</h5>
                            <hr/>
                       <div class="details-table">
                            <div class="label">DATE / SHIFT </div><div>:  ${palletdet.shift_date || ''} / ${palletdet.shift_code || ''}</div> 
                            <div class="label">PALLET CODE</div><div>: ${palletdet.pallet_code}</div> 
                            <div class="label">REEL NUMBER</div><div>: ${palletdet.cr_number}</div> 
                            <div class="label">QUALITY</div><div>: ${palletdet.item_code}</div> 
                            <div class="label">SIZE</div><div>: ${palletdet.size}</div>  
                            <div class="label">GSM</div><div>: ${palletdet.gsm}</div> 
                            <div class="label">PALLET WEIGHT (KG)</div><div>: ${palletdet.pallet_weight}</div> 
                            <div class="label">NO.OF.SHEETS</div><div>: ${palletdet.no_of_sheets}</div> 
                            <div class="label">MO NO</div><div>: ${palletdet.release_no}</div> 
                            <div class="label">MA NO</div><div>: ${palletdet.lot_no}</div> 
                            <div class="label">SO NO</div><div>: ${palletdet.indent_no}</div> 
                             <div class="label">CUSTOMER NAME</div><div>: ${palletdet.customer_name}</div> 
                            <div class="label">REMARKS</div><div>:</div>            
                        
                        </div>
                         
                    </div>
                      
                </div>
                    </body>
                </html>
            
            
                
            `);

                // }    // <h6>Size : ${size}</h6>
                // Close the print window and print the report
                // printWindow.document.close();
                // printWindow.print();
            } catch (error) {
                console.error('Error handling button click:', error);
            }


        }



    };
    const generateQRCode = async (value) => {
        try {
            const qrDataUrl = await qrcode.toDataURL(value);
            return qrDataUrl;
        } catch (error) {
            console.error('Error generating QR code:', error);
            return null;
        }
    };
    return (

        <>
            {ProductDetail.map((detail, index) => (
                <>
                    <Card sx={{ backgroundColor: "transparent", m: 2, padding: 1 }} >
                        <Box mb={2}>
                            <Typography variant="h5" textAlign="center" > PALLET DETAIL </Typography>
                        </Box>
                        <Divider sx={{ marginBottom: "10px" }} />

                        <Grid container spacing={0} justifyContent="space-between" alignItems="center">
                            <Grid item xs={12} lg={8}>
                                <Grid container spacing={0}>
                                    {/* Date and Shift */}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">{`DATE / SHIFT `}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={7}>
                                        <Typography variant="h7">: {` ${detail.shift_date || ''} / ${detail.shift_code || ''}`}</Typography>
                                    </Grid>

                                    {/* M.O No */}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">PALLET NUMBER </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">: {detail.pallet_code}</Typography>
                                    </Grid>

                                    {/* Quantity */}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">REEL NUMBER </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">: {detail.cr_number}</Typography>
                                    </Grid>

                                    {/* GSM */}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">QUALITY </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={7}>
                                        <Typography variant="h7">: {detail.item_code}</Typography>
                                    </Grid>

                                    {/* No. Set */}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">SIZE </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">: {detail.size}</Typography>
                                    </Grid>

                                    {/* ID / OD */}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">GSM </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">: {detail.gsm}</Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">PALLET.WT (KG)</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">: {detail.pallet_weight}</Typography>
                                    </Grid>

                                    {/* TOTAL SHEETS */}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">NO.OF.SHEETS</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">: {detail.no_of_sheets || 0}</Typography>
                                    </Grid>
                                    {/* mo */}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">MO NO</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">: {detail.release_no || 0}</Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">MA NO</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">: {detail.lot_no || 0}</Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">SO NO</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">: {detail.indent_no || 0}</Typography>
                                    </Grid>

                                    {/* TOTAL SHEETS */}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">CUSTOMER NAME</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">: {detail.customer_name || 0}</Typography>
                                    </Grid>


                                    {/* SUPPLIER :*/}
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">REMARKS </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} lg={5}>
                                        <Typography variant="h7">: </Typography>
                                    </Grid>

                                </Grid>
                            </Grid>

                            {/* QR Code */}
                            <Grid item xs={12} lg={4} textAlign="center">
                                <Typography variant="h7">{detail.pallet_code}</Typography>
                                <QRCodeGenerator value={detail.pallet_code} />
                            </Grid>
                        </Grid>

                        <Divider sx={{ marginTop: "5px", marginBottom: "5px" }} />


                        {hasPermission(userPermissions, "Cutter Sheeter Convertion", "Print") && (
                            <Box item mt={2} xs={12} lg={12} display="flex" justifyContent="flex-end">
                                <Button size="small" sx={{ textTransform: "none" }} variant="contained" color="secondary" onClick={() => handleButtonClick(detail.pallet_code)}>Print</Button>
                            </Box>
                        )}

                    </Card>
                </>
            ))}
        </>
    );

}
export default LabelPalletDetails;